import makeStyles from "@mui/styles/makeStyles";
import {
  Grow,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TableSortLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import {
  convertedColumnName,
  getPersonnelSummaryColumns,
  getTitle,
} from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import ls from "local-storage";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import {
  getPersonnelSummary,
  getList,
} from "../../store/actions/PersonalSummaryActions";
import { getShifts } from "../../store/actions/ShiftActions";
import {
  getUserInfo,
  getTechnicianList,
} from "../../store/actions/userActions";
import GenericDatePicker from "../../components/GenericDatePicker/GenericDatePicker";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";

const useStyles = makeStyles((_theme) => ({
  popupElement: {
    width: "100%",
    marginTop: 10,
  },
  autocompleteComponent: {
    width: "100%",
    marginTop: -7,
    marginBottom: -7,
  },
}));

const plantId = localStorage.getItem("plantId");

function PersonnelSummaryList() {
  const dispatch = useDispatch();
  const PersonalSummary = useSelector((state) => state.PersonalSummary);
  const { shiftList } = useSelector(({ Shifts }) => Shifts);

  const [sortItem, setSortItem] = useState(null);

  useEffect(() => {
    const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
    dispatch(
      getUserInfo(
        oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "")
      )
    );
    dispatch(getTechnicianList());
    dispatch(getList());
    dispatch(getShifts());
    getPersonnelSummaryHandler();
  }, []);

  useEffect(() => {
    if (PersonalSummary.poolList) {
      setPageLoaded(true);
      setPoolData(Object.values(PersonalSummary.poolList));
    }
  }, [PersonalSummary.poolList]);

  useEffect(() => {
    if (PersonalSummary?.personnelSummary) {
      setPageLoaded(true);
      setRows(PersonalSummary.personnelSummary);
    }
  }, [PersonalSummary.personnelSummary]);

  const {
    user: { technicianList },
  } = useSelector((user) => user);

  //technicianList, setTechnicianList state
  const [technicians, setTechnicians] = useState([]);
  useEffect(() => {
    if (technicianList) {
      setPageLoaded(true);
      setTechnicians(technicianList);
    }
  }, [technicianList]);

  //load shift data
  let [shiftData, setShiftData] = useState([]);
  useEffect(() => {
    if (shiftList?.resultObject?.length > 0) {
      setShiftData(shiftList.resultObject[0].shifts);
    }
  }, [shiftList]);

  const getPersonnelSummaryHandler = () => {
    var data = {
      poolIds: ls.get("ps_poolId_" + plantId) || state.poolIds,
      assigneeIds: ls.get("ps_assigneeId_" + plantId) || state.assigneeIds,
      startDate: ls.get("ps_startDate") || GetFirstDayOfWeek(),
      endDate: ls.get("ps_endDate") || GetLastDayOfWeek(),
      shifts: ls.get("ps_shiftNo") || [],
    };
    dispatch(getPersonnelSummary(data));
  };

  const { t } = useTranslation("translation");

  const GetFirstDayOfWeek = () => {
    var curr = new Date(); // get current date
    var first = curr.getDate() - curr.getDay() + 1;

    return new Date(curr.setDate(first));
  };

  const GetLastDayOfWeek = () => {
    var curr = new Date(); // get current date
    var first = curr.getDate() - curr.getDay() + 1;

    return new Date(curr.setDate(first + 6));
  };

  //pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const HandleChangePage = (event) => {
    setPage(event);
  };

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(event);
    setPage(0);
  };

  const handleSort = (columnName) => {
    setSortItem({
      ...sortItem,
      propertyName: convertedColumnName(columnName), //Added to convert column name like "id" to "Id" because of sorting on backend-side
      direction:
        sortItem?.propertyName === convertedColumnName(columnName)
          ? invertSortDirection(sortItem?.direction)
          : 0,
    });
  };

  const invertSortDirection = (direction) => (direction === 0 ? 1 : 0);

  const classes = useStyles();
  const [pageLoaded, setPageLoaded] = useState(false);

  const [rows, setRows] = useState([]);
  const [poolData, setPoolData] = useState([]);

  //states
  const [state, setState] = useState({
    pool: null,
    poolIds: [],
    assigneeIds: [],
    startDate: ls.get("ps_startDate") || GetFirstDayOfWeek(),
    endDate: ls.get("ps_endDate") || GetLastDayOfWeek(),
    shiftIds: ls.get("ps_shiftNo") || [],
  });

  let timeIntervals = [
    { id: 1, name: t("Today") },
    { id: 2, name: t("ThisWeek") },
    { id: 3, name: t("ThisMonth") },
    { id: 4, name: t("Manual") },
  ];
  let [selectedTimeInterval, setSelectedTimeInterval] = useState(
    ls.get("ps_interval") || 2
  );

  const HandleTimeInterval = (e) => {
    setSelectedTimeInterval(e.target.value);
    ls.set("ps_interval", e.target.value);
    HandleTimeSelection(e.target.value);
  };

  const SetDates = (start, end) => {
    setState({ ...state, startDate: start, endDate: end });
    ls.set("ps_startDate", start);
    ls.set("ps_endDate", end);
  };

  const HandleTimeSelection = (id) => {
    switch (id) {
      //today
      case 1:
        var start = new Date();
        start.setHours(0, 0, 0, 0);
        var end = new Date();
        end.setHours(23, 59, 59, 999);
        SetDates(start, end);
        getPersonnelSummaryHandler();
        break;
      //this week
      case 2:
        SetDates(GetFirstDayOfWeek(), GetLastDayOfWeek());
        getPersonnelSummaryHandler();
        break;
      //this month
      case 3:
        var date = new Date();
        var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDayOfMonth = new Date(
          date.getFullYear(),
          date.getMonth() + 1,
          0
        );
        lastDayOfMonth.setHours(23, 59, 59, 999);
        SetDates(firstDayOfMonth, lastDayOfMonth);
        getPersonnelSummaryHandler();
        break;
      default:
        break;
    }
  };
  //set pool
  const HandleAssignees = (assineeName) => {
    let ids = [];
    assineeName.map((item) => ids.push(item.id));
    setState({ ...state, assigneeIds: ids });
    ls.set("ps_assigneeId_" + plantId, ids);
    getPersonnelSummaryHandler();
  };

  //set pool
  const HandlePool = (poolName) => {
    let ids = [];
    poolName.map((item) => ids.push(item.id));
    setState({ ...state, poolIds: ids });
    ls.set("ps_poolId_" + plantId, ids);
    getPersonnelSummaryHandler();
  };

  //set start date
  const HandleStartDate = (date) => {
    setState({ ...state, startDate: date });
    ls.set("ps_startDate", date);
    getPersonnelSummaryHandler();
  };

  //set end date
  const HandleEndDate = (date) => {
    date.setHours(23, 59);
    setState({ ...state, endDate: date });
    ls.set("ps_endDate", date);
    getPersonnelSummaryHandler();
  };

  const HandleShift = (shiftNo) => {
    let shiftIds = [];
    if (shiftNo != null) {
      shiftNo.map((item) => shiftIds.push(item.shiftNo.toString()));
      setState({ ...state, shiftIds: shiftIds });
      ls.set("ps_shiftNo", shiftIds);
    }
    getPersonnelSummaryHandler();
  };

  const columnVisibilityModelData =
    JSON.parse(localStorage.getItem("columnVisibilityModel")) || {};
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(
    columnVisibilityModelData
  );

  const customToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarDensitySelector />
        <GridToolbarColumnsButton name="column" />
        {/* <GridToolbarFilterButton /> */}
      </GridToolbarContainer>
    );
  };

  const handleChangeVisibility = (newModel) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem("columnVisibilityModel", JSON.stringify(newModel));
  };

  return (
    <StyledTableDiv>
      {getTitle(t("PersonnelSummaryList"))}
      {pageLoaded === true ? (
        <Grid id="ps_Grid_1" container justifyContent="center">
          <Grid id="ps_Grid_3" item xs={3} style={{ marginTop: 4 }}>
            <FormControl
              id="ps_formControl_2"
              variant="outlined"
              style={{ width: "90%" }}
            >
              <Autocomplete
                multiple
                id="ps_Autocomplete_2"
                options={poolData}
                limitTags={5}
                value={poolData.filter((item) =>
                  ls.get("ps_poolId_" + plantId)?.includes(item.id)
                )}
                defaultValue={poolData.filter((item) =>
                  ls.get("ps_poolId_" + plantId)?.includes(item.id)
                )}
                disableCloseOnSelect
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    label={t("Pool")}
                    variant="outlined"
                    id="bl_table_TextField_0"
                  />
                )}
                onChange={(event, newValue) => {
                  HandlePool(newValue);
                }}
                renderOption={(_props, option) => (
                  <li {..._props}>{option.name}</li>
                )}
              />
            </FormControl>
          </Grid>

          <Grid id="ps_Grid_2" item xs={3} style={{ marginTop: 4 }}>
            <FormControl
              id="ps_formControl_1"
              variant="outlined"
              style={{ width: "90%" }}
            >
              <Autocomplete
                multiple
                id="ps_Autocomplete_1"
                options={technicians}
                limitTags={5}
                value={technicians.filter((item) =>
                  ls.get("ps_assigneeId_" + plantId)?.includes(item.id)
                )}
                defaultValue={technicians.filter((item) =>
                  ls.get("ps_assigneeId_" + plantId)?.includes(item.id)
                )}
                disableCloseOnSelect
                getOptionLabel={(option) => option.userName}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    label={t("Persons")}
                    variant="outlined"
                    id="bl_table_TextField_0"
                  />
                )}
                onChange={(event, newValue) => {
                  HandleAssignees(newValue);
                }}
                renderOption={(_props, option) => (
                  <li {..._props}>{option.userName}</li>
                )}
              />
            </FormControl>
          </Grid>

          <Grid id="ps_Grid_4" item xs={3} style={{ marginTop: 20 }}>
            <FormControl
              id="ps_formControl_3"
              variant="outlined"
              style={{ width: "90%" }}
            >
              <InputLabel>{t("Time")}</InputLabel>
              <Select
                label={t("Time")}
                value={selectedTimeInterval}
                onChange={HandleTimeInterval}
              >
                {timeIntervals.map((data) => (
                  <MenuItem key={data.id} value={data.id}>
                    {data.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid id="ps_Grid_2" item xs={3} style={{ marginTop: 4 }}>
            <FormControl
              id="ps_formControl_1"
              variant="outlined"
              style={{ width: "90%" }}
            >
              <Autocomplete
                id="cpm_Shift_Autocomplete"
                multiple
                options={shiftData}
                limitTags={5}
                value={shiftData.filter((item) =>
                  ls.get("ps_shiftNo")?.includes(item.shiftNo.toString())
                )}
                disableCloseOnSelect
                getOptionLabel={(option) => option.shiftNo.toString()}
                renderInput={(params) => (
                  <TextField
                    id="cpm_TextField_5"
                    {...params}
                    margin="normal"
                    label={t("Shift")}
                    variant="outlined"
                  />
                )}
                onChange={(event, newValue) => {
                  HandleShift(newValue);
                }}
                renderOption={(_props, option) => (
                  <li {..._props}>{option.shiftNo.toString()}</li>
                )}
              />
            </FormControl>
          </Grid>
          {selectedTimeInterval === 4 ? (
            <Grid id="ps_Grid_5" container justifyContent="center">
              <Grid
                id="ps_Grid_6"
                item
                xs={2.5}
                style={{ marginTop: 10, marginRight: 20, marginBottom: 10 }}
              >
                <GenericDatePicker
                  id="ps_DatePicker"
                  label={t("StartDate")}
                  minDate={new Date("1900-01-01")}
                  minDateTime={new Date("1900-01-01")}
                  dateValue={ls.get("ps_startDate") || state.startDate}
                  onDateChange={HandleStartDate}
                />
              </Grid>
              <Grid
                id="ps_Grid_7"
                item
                xs={2.5}
                style={{ marginTop: 10, marginLeft: 20 }}
              >
                <GenericDatePicker
                  id="ps_DatePicker_1"
                  label={t("EndDate")}
                  minDate={ls.get("ps_startDate") || state.startDate}
                  dateValue={ls.get("ps_endDate") || state.endDate}
                  onDateChange={HandleEndDate}
                />
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      ) : null}
      {rows.length > 0 ? (
        <Grow
          in={true}
          style={{ transformOrigin: "0 0 0" }}
          {...{ timeout: 1000 }}
        >
          <div style={{ width: "100%", textAlign: "center" }}>
            <DataGrid
              autoHeight={true}
              rows={rows}
              columns={getPersonnelSummaryColumns()}
              pageSize={rowsPerPage}
              onPageSizeChange={HandleChangeRowsPerPage}
              onPageChange={HandleChangePage}
              rowsPerPageOptions={[5, 10, 20, 50]}
              rowCount={rows.length} //total count
              page={page}
              //paginationMode="server"
              disableColumnFilter
              disableColumnMenu
              components={{
                Toolbar: customToolbar,
              }}
              filterMode="server"
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={(newModel) =>
                handleChangeVisibility(newModel)
              }
              //onSortModelChange={(sortModel) => handleSort(sortModel)}
              getRowId={(row) => row.userId}
              sx={{
                boxShadow: 5,
                "& .MuiDataGrid-row:hover": {
                  color: "primary.main",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
                "& .default-row-color": {
                  backgroundColor: "#f6f9f5",
                  color: "#1a3e72",
                  fontWeight: "600",
                },
                "& .planned-row-color": {
                  backgroundColor: "#EAF2E8",
                  color: "#1a3e72",
                  fontWeight: "600",
                },
                "& .unPlanned-row-color": {
                  backgroundColor: "rgb(198,218,214)",
                  color: "#1a3e72",
                  fontWeight: "600",
                },
              }}
              localeText={{
                toolbarColumns: t("Columns"),
                columnsPanelTextFieldLabel: t("ColumnsPanelTextFieldLabel"),
                columnsPanelTextFieldPlaceholder: t(
                  "ColumnsPanelTextFieldPlaceholder"
                ),
                columnsPanelShowAllButton: t("ColumnsPanelShowAllButton"),
                columnsPanelHideAllButton: t("ColumnsPanelHideAllButton"),
                toolbarDensity: t("Density"),
                toolbarDensityCompact: t("DensityCompact"),
                toolbarDensityStandard: t("DensityStandard"),
                toolbarDensityComfortable: t("DensityComfortable"),
              }}
            />
          </div>
        </Grow>
      ) : null}
      <LoadingBackdrop />
    </StyledTableDiv>
  );
}
export default withRouter(PersonnelSummaryList);
